import React from 'react';
import './Avatar.scss';

/**
 * 共用的頭像元件
 * 
 * @param {string} avatarUrl - 頭像 URL（來自 Supabase Storage）
 * @param {string} name - 使用者名稱（用於顯示首字母備用）
 * @param {string} size - 尺寸：'small' (32px), 'medium' (48px), 'large' (80px)
 * @param {string} className - 額外的 CSS class
 */
const Avatar = ({ avatarUrl, name, size = 'medium', className = '' }) => {
  const [imageError, setImageError] = React.useState(false);
  
  // 取得首字母
  const getInitial = () => {
    if (!name) return '?';
    return name.charAt(0).toUpperCase();
  };
  
  // 如果有頭像 URL 且沒有載入錯誤，顯示圖片
  const showImage = avatarUrl && !imageError;
  
  return (
    <div className={`avatar avatar-${size} ${className}`}>
      {showImage ? (
        <img 
          src={avatarUrl} 
          alt={name || '使用者頭像'}
          onError={() => setImageError(true)}
          className="avatar-image"
        />
      ) : (
        <div className="avatar-initial">
          {getInitial()}
        </div>
      )}
    </div>
  );
};

export default Avatar;





